angular
    .module('lingoda.form', [])
    .directive('lingFormValidation', [
        '$timeout',
        '$debounce',
        'helper',
        function ($timeout, $debounce, helper) {
            return {
                restrict: 'C',
                scope: true,
                controller: [
                    '$scope',
                    function ($scope) {
                        var messages = {
                                required: 'Please fill out this field!',
                                email: 'Please enter an email address!',
                                number: 'Please enter a number!',
                                url: 'Please enter a URL!',
                                pattern: 'Invalid input!',
                                minlength: 'Too short!',
                                maxlength: 'Too long!',
                            },
                            timeoudID,
                            lang = $('html').attr('lang');

                        $scope.$parent.$on(
                            'ling:form:validate',
                            function (e, model, target, timeout) {
                                timeout = timeout || 5;
                                var i = 0;
                                angular.forEach(model.$error, function (v, type) {
                                    if (i === 0 && v) {
                                        $scope.message = messages[type] || model[type];
                                        i++;
                                    }
                                    return false;
                                });
                                $scope.target = target;

                                if (timeoudID) {
                                    $timeout.cancel(timeoudID);
                                }

                                //Hide validation
                                timeoudID = $timeout(function () {
                                    $scope.target = null;
                                }, timeout * 1000);

                                if (!helper.isMobile()) {
                                    var x = window.scrollX,
                                        y = window.scrollY;
                                    $scope.target.focus();
                                    window.scrollTo(x, y);
                                }

                                $timeout($scope.refreshPosition);
                            },
                        );
                    },
                ],
                link: function (scope, iElement) {
                    scope.refreshPosition = function () {
                        if (!scope.target) {
                            return;
                        }

                        var top = $(scope.target).offset().top,
                            left = $(scope.target).offset().left,
                            height = $(scope.target).outerHeight(),
                            width = $(scope.target).outerWidth(),
                            zIndex = 9,
                            parents = $(scope.target).parents(':not(html, body)');

                        //Get parent z-index
                        parents.pushStack($(scope.target)[0]);
                        angular.forEach(parents.get().reverse(), function (elem) {
                            var newZIndex = $(elem).css('z-index');
                            if (newZIndex > 9 && zIndex === 9) {
                                zIndex = newZIndex;
                            }
                        });

                        iElement.css({
                            top: top + height,
                            left: left,
                            width: width,
                            zIndex: zIndex,
                        });
                    };

                    angular.element(document.body).on('click', function () {
                        scope.target = null;
                        scope.$apply();
                    });

                    angular.element(window).bind('resize scroll', function () {
                        $timeout(scope.refreshPosition);
                    });
                },
            };
        },
    ])
    .factory('requestService', [
        '$rootScope',
        function ($rootScope) {
            var requests = [];
            return {
                add: function (request) {
                    if (!requests.length) {
                        $rootScope.pendingRequests = true;
                    }
                    requests.push(request);
                },
                remove: function (request) {
                    angular.forEach(requests, function (currentRequest, i) {
                        if (request === currentRequest) {
                            requests.splice(i, 1);
                        }
                    });
                    if (!requests.length) {
                        $rootScope.pendingRequests = false;
                    }
                },
            };
        },
    ])
    .controller('RequestController', [
        '$scope',
        '$timeout',
        '$compile',
        function ($scope, $timeout, $compile) {
            var self = this;

            //Defaults
            $scope.form = {};
            $scope.result = null;
            if (!$scope.$parent.result) {
                $scope.$parent.result = null;
            }
            $scope.seo = '';
            $scope._disabled = false;

            this.showMessages = function () {
                if (
                    !$scope.ignoreMessages &&
                    $scope.result &&
                    angular.isDefined($scope.result.messages)
                ) {
                    angular.forEach($scope.result.messages, function (types, type) {
                        angular.forEach(types, function (message, key) {
                            var field, model;
                            //Try to find it
                            field = $scope._form.find('[name="' + key + '"]:eq(0)');
                            if (!field.length) {
                                field = $(document.body).find('[name="' + key + '"]:eq(0)');
                            }
                            if (field.length && type === 'error') {
                                $timeout(function () {
                                    model = field.controller('ngModel');
                                    if (model) {
                                        model.$setValidity('ajaxError', false);
                                        // So this is a really hacky way to show error and then right away
                                        // remove it since we have no way to validate it.
                                        // Otherwise, if we don't do this, we can't submit form.
                                        model.$validators.ajaxError = function () {
                                            return true;
                                        };
                                        model.ajaxError = message.content;
                                        $scope.$emit(
                                            'ling:form:validate',
                                            model,
                                            field,
                                            message.timeout,
                                        );
                                    } else {
                                        $scope.$emit(
                                            'mainMessages:add',
                                            $.extend(true, {}, { type: type }, message),
                                        );
                                    }
                                }, 300);
                            } else {
                                $scope.$emit(
                                    'mainMessages:add',
                                    $.extend(
                                        true,
                                        {},
                                        {
                                            type: type,
                                        },
                                        message,
                                    ),
                                );
                            }
                        });
                    });
                }
            };

            this.success = function (resp, prop) {
                prop = $.extend(
                    {
                        skipSet: false,
                        responseModal: null,
                    },
                    prop,
                );

                /* Catch backend error */
                var result = null;
                try {
                    result = typeof resp === 'string' ? $.parseJSON(resp) : resp;
                } catch (o) {
                    if (prop.responseModal) {
                        var $modal = $('#modalForm'),
                            $modalLoader = $modal.find('[data-remote-loader]:eq(0)');

                        $modalLoader.children(':not(:first)').remove();
                        $modalLoader.append(resp);
                        $modal.modal('show');
                        $compile($modalLoader.children())($modal.scope());
                    } else {
                        $scope.$emit('mainMessages:add', {
                            type: 'error',
                            content: !lingoda.environment.prod
                                ? o.message
                                : 'There was an error processing your request. Please try again.',
                        });
                    }
                }

                /* redirectURL */
                if (result && result.redirectURL) {
                    window.location = result.redirectURL;
                    return false;
                }

                /* reload */
                var reload = false;
                if (result && result.reload) {
                    $scope.setUrl(result.reload.url, result.reload.timeout);
                    reload = true;
                }

                /* update */
                if (result && result.update) {
                    $timeout(function () {
                        //ID
                        if (result.update.direction.charAt(0) === '#') {
                            $scope.$root.$broadcast(
                                'remoteLoader:load',
                                {},
                                {
                                    id: result.update.direction.substring(1),
                                },
                            );
                        } else if (result.update.direction === 'parent') {
                            $scope.$emit('remoteLoader:load');
                        } else if (result.update.direction === 'child') {
                            $scope.$parent.$broadcast('remoteLoader:load');
                        }
                    });
                }

                if (result && result.global) {
                    for (var key in result.global) {
                        if (!result.global.hasOwnProperty(key)) {
                            continue;
                        }
                        $scope.$root.global[key] = result.global[key];
                    }
                }

                if (!prop.skipSet) {
                    if (!reload) {
                        $timeout(function () {
                            $scope.$parent.formloader[$scope.name] = false;
                        }, $scope.loaderFadeDelay || 0);
                    }

                    if (result) {
                        $scope.result = result;
                        if (!$scope.disableResult) {
                            $scope.$parent.result = $scope.result;
                        }

                        if ($scope.actionId) {
                            $scope.$parent[$scope.actionId] = $scope.result;
                        }

                        //Form modal
                        if (result.success && prop.name) {
                            $scope.$emit('modal:hide');
                        }

                        $scope.$apply();
                        $scope.$parent.$broadcast('ling:form:response:done', $scope.result, prop);
                        $scope.$parent.$emit('ling:form:response:done', $scope.result, prop);
                    }
                }

                $timeout(self.showMessages, $scope.messagesDelay);

                return result;
            };

            this.failure = function (prop) {
                prop = $.extend(
                    {
                        skipSet: false,
                    },
                    prop,
                );

                if (!$scope.ignoreMessages) {
                    $scope.$emit('mainMessages:add', {
                        type: 'error',
                        content: 'There was an error processing your request. Please try again.',
                    });
                }

                if (!prop.skipSet) {
                    $timeout(function () {
                        $scope.$parent.formloader[$scope.name] = false;
                    }, $scope.loaderFadeDelay || 0);
                    $scope.$parent.$broadcast('ling:form:response:fail');
                    $scope.$parent.$emit('ling:form:response:fail');
                }
            };

            this.disable = function () {
                $scope._disabled = true;
            };
            this.enable = function () {
                $scope._disabled = false;
            };

            $scope._success = this.success;
            $scope._failure = this.failure;
        },
    ])
    //Deprecated
    .controller('LingFormController', function () {})
    .directive('lingForm', [
        '$compile',
        '$timeout',
        'helper',
        '$parse',
        'requestService',
        function ($compile, $timeout, helper, $parse, requestService) {
            return {
                restrict: 'C',
                controller: 'RequestController',
                scope: {
                    action: '@',
                    name: '@',
                    method: '@',
                    ajax: '@',
                    manualLoader: '@',
                    loaderFadeDelay: '@',
                    disableResult: '@',
                    initSubmit: '@',
                    preventSubmit: '@',
                    preventSubmitTrigger: '@',
                    seo: '@',
                    actionId: '@',
                    formModel: '@',
                    ignoreMessages: '@',
                    messagesDelay: '@',
                    onlySpecifiedTrigger: '@',
                    initiatedValidation: '@',
                    responseModal: '@',
                    blur: '@',
                },
                link: function (scope, iElement, iAttrs) {
                    //Init
                    var ajax = !angular.isDefined(scope.ajax) || scope.ajax === 'true',
                        blur = !angular.isDefined(scope.blur) || scope.blur === 'true',
                        form = iElement,
                        additionalParams = null,
                        validate = true,
                        defaultAction = scope.action,
                        currentRequest = null;

                    scope.messagesDelay = scope.messagesDelay || 301;
                    scope._form = form;

                    scope.$watch('seo', function () {
                        var action = '';
                        if (!angular.isDefined(defaultAction)) {
                            action = window.location.href;
                        } else {
                            action = defaultAction;
                        }
                        action = action + (scope.seo || '');
                        iAttrs.$set('action', action);
                        scope.action = action;
                    });
                    iAttrs.$set('novalidate', '');

                    /* Setup form models */
                    if (lingoda.forms && lingoda.forms[scope.formModel]) {
                        scope.$parent[scope.formModel] = $.extend(
                            true,
                            {},
                            lingoda.forms[scope.formModel],
                        );

                        scope.$parent.getOriginalValue = function (model) {
                            var originalModel = $.extend(true, {}, lingoda.forms[scope.formModel]),
                                model = model.match(/\['(.*)'\]/)[1].split("']['");
                            angular.forEach(model, function (slice) {
                                originalModel = originalModel[slice];
                            });
                            return originalModel;
                        };
                    }

                    scope.setUrl = function (url, timeout) {
                        $timeout(function () {
                            iAttrs.$set('action', url);
                            form.submit();
                        }, timeout * 1000);
                    };

                    scope.validateForm = function () {
                        //Validation check / trigger validation display
                        var validationParent = scope.getValidationParent();
                        validationParent.addClass('ling-form-submitted');
                        if (
                            validationParent.find('.ng-invalid:not(.form-select):not(.ling-select)')
                                .length
                        ) {
                            var firstInvalid = validationParent.find(
                                '.ng-invalid:not(.form-select):not(.ling-select):eq(0)',
                            );
                            scope.$emit(
                                'ling:form:validate',
                                firstInvalid.controller('ngModel'),
                                firstInvalid,
                            );
                            return false;
                        } else {
                            return true;
                        }
                    };
                    scope.$parent.validateForm = scope.validateForm;

                    scope.getValidationParent = function () {
                        return form.find('.ling-form-validate').length
                            ? form.find('.ling-form-validate')
                            : form;
                    };

                    if (!scope.$parent.formloader) {
                        scope.$parent.formloader = {};
                    }

                    form.on('submit', function (e) {
                        if (scope._disabled) {
                            scope.$emit('mainMessages:add', {
                                type: 'generic',
                                content: 'The form is disabled, please wait...',
                            });
                            return false;
                        }

                        if (validate && !scope.validateForm()) {
                            return false;
                        }

                        //Set back to default
                        validate = true;

                        if (scope.preventSubmit && scope.$parent.$eval(scope.preventSubmit)) {
                            if (scope.preventSubmitTrigger) {
                                scope.$parent.$eval(scope.preventSubmitTrigger);
                                scope.$parent.$apply();
                            }
                            return false;
                        }

                        var method = angular.isDefined(scope.method) ? scope.method : 'GET',
                            fields = form.serialize();

                        if (additionalParams) {
                            if (fields) {
                                fields += '&' + $.param(additionalParams);
                            } else {
                                fields += $.param(additionalParams);
                            }
                        }

                        //If not ajax then disable the submit button
                        if (!ajax) {
                            var submit = iElement.find('button[type="submit"]');
                            if (submit.attr('disabled')) {
                                e.preventDefault();
                                e.stopPropagation();
                            } else if (!e.isDefaultPrevented()) {
                                submit.attr('disabled', 'disabled');
                            }
                        }
                        //If ajax and not prevented by custom validation
                        else {
                            e.preventDefault();

                            if (form.find(document.activeElement).length && blur) {
                                document.activeElement.blur();
                            }

                            //Init loader
                            scope.$parent.formloader[scope.name] = true;
                            scope.$emit('ling:form:request:start');
                            scope.$apply();

                            //Send request
                            if (currentRequest) {
                                requestService.remove(currentRequest);
                                currentRequest.abort();
                            }
                            currentRequest = $.ajax(iAttrs.action, {
                                data: fields,
                                type: method,
                            })
                                .done(function (resp) {
                                    scope._success(resp, iAttrs);
                                    scope.refreshFields();
                                    requestService.remove(currentRequest);
                                })
                                .fail(function (xhr, textStatus) {
                                    if (textStatus !== 'abort') {
                                        scope._failure();
                                    }
                                    requestService.remove(currentRequest);
                                });
                            requestService.add(currentRequest);
                        }
                    });

                    scope.refreshFields = function () {
                        var fieldsObj = {},
                            fieldsArr = form.serializeArray();
                        angular.forEach(fieldsArr, function (field) {
                            var root = field.name.match(/.*?\[/),
                                structure = field.name.match(/\[.*?\]/g),
                                fieldEl = $('[name="' + field.name + '"]'),
                                fieldName = root ? root[0].slice(0, -1) : field.name,
                                getFieldValue = function (fieldEl, fieldScope) {
                                    if (fieldEl.is(':radio')) {
                                        fieldEl = fieldEl.filter(':checked');
                                    }

                                    var fieldValue = fieldScope
                                        ? fieldScope
                                        : {
                                              display: field.value,
                                          };
                                    if (fieldEl.data('display')) {
                                        fieldValue = {
                                            display: fieldEl.data('display'),
                                            value: field.value,
                                        };
                                    }
                                    return fieldValue;
                                },
                                createNamespace = function () {
                                    var obj = fieldsObj,
                                        fieldScope = null,
                                        lastKey = null;
                                    helperField = null;

                                    while (root.length) {
                                        key = root.shift().replace(/[\[\]]/g, '');
                                        //[] (last section)
                                        if (key === '') {
                                            if (fieldEl.filter(':checkbox').length) {
                                                helperField = fieldEl.filter(
                                                    ':checked:eq(' + obj.length + ')',
                                                );
                                            } else {
                                                helperField = fieldEl.filter(
                                                    ':eq(' + obj.length + ')',
                                                );
                                            }
                                            fieldScope = helperField.scope().field;
                                            obj = obj[obj.length] = getFieldValue(
                                                helperField,
                                                fieldScope,
                                            );
                                        } else {
                                            fieldScope = fieldEl.scope().field;
                                            obj = obj[key] =
                                                obj[key] ||
                                                (root.length === 0
                                                    ? getFieldValue(fieldEl, fieldScope)
                                                    : root[0] === '[]'
                                                      ? []
                                                      : {});
                                        }
                                        lastKey = key;
                                    }
                                };

                            if (root) {
                                if (structure) {
                                    root = root.concat(structure);
                                }
                                createNamespace();
                            } else {
                                fieldsObj[fieldName] = getFieldValue(
                                    fieldEl,
                                    fieldEl.scope().field,
                                );
                            }
                        });

                        scope.$parent.fields = fieldsObj;
                    };

                    scope.$parent.setFieldValue = function (model, value) {
                        $parse(model).assign(scope.$parent, value);
                    };

                    scope.$parent.$on('ling:form:submit', function (e, data) {
                        //Cause of digging
                        $timeout(function () {
                            additionalParams = null;
                            if (data && data.params) {
                                additionalParams = data.params;
                            }
                            if (data && data.validate === false) {
                                validate = false;
                            }
                            if (data && data.name) {
                                if (data.name === scope.name) {
                                    form.submit();
                                }
                            } else if (!scope.onlySpecifiedTrigger) {
                                form.submit();
                            }
                        }, 25);
                    });

                    scope.$parent.$on('ling:form:refreshFields', scope.refreshFields);

                    //Init submit
                    if (scope.initSubmit) {
                        $timeout(function () {
                            form.submit();
                        });
                    }

                    if (scope.initiatedValidation) {
                        scope.getValidationParent().addClass('ling-form-submitted');
                    }

                    $timeout(function () {
                        scope.refreshFields();
                        scope.$parent.$broadcast('ling:form:initialized');
                    });
                },
            };
        },
    ])
    .directive('lingFormReset', [
        '$parse',
        function ($parse) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    scope.$on('ling:form:response:done', function (e, result) {
                        if (result.success) {
                            $parse(attrs.ngModel).assign(scope, '');
                        }
                    });
                },
            };
        },
    ])
    .directive('lingFormConfirm', function () {
        return {
            restrict: 'C',
            link: function (scope, element) {
                element.on('click', function (e) {
                    if (!scope.validateForm()) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                });
            },
        };
    });
